
























import { Prop, Component, Vue } from "vue-property-decorator";
import getGoogleMapsURL, {
  getGoogleMapsURLOfPlace
} from "@/helpers/getGoogleMapsURL";

interface Location {
  postcode: string;
  address: string;
  latitude: number;
  longitude: number;
}

@Component({})
export default class AppLocation extends Vue {
  @Prop({ required: true }) location!: Location;

  places = ["コンビニ", "トイレ", "ホームセンター", "駐車場"];

  get googleMapsURL() {
    return getGoogleMapsURL(this.location.latitude, this.location.longitude);
  }

  googleMapsURLOfPlace(query: string): string {
    return getGoogleMapsURLOfPlace(this.location.address + " " + query);
  }
}
